import { baseApiManagerUrl } from '../actions/urls';

const urls = {
  vacunas: {
    getVacunas: `${baseApiManagerUrl}/V1/prestadores/:code/medical-attention/vacunas`,
  },
  // general: {
  //   getRentals: `${baseApiManagerUrl}/V2/prestadores/:code/sap/alquilermarca`,
  //   getSocieties: `${baseApiManagerUrl}/V1/prestadores/:code/sociedades`,
  //   validate: `${baseApiManagerUrl}/V1/prestadores/:code/cuit/:cuit/validar`,
  //   rudiFiles: `${baseApiManagerUrl}/V1/prestadores/:code/rudi/transactions/:number/types/:type/files`,
  // },
  // // transactions is to payments, invoices and consulting service
  // transactions: {
  //   invoices: `${baseApiManagerUrl}/V1/prestadores/:code/cuit/:cuit/facturas`,
  //   companies: `${baseApiManagerUrl}/V1/prestadores/:code/pagos-facturas/empresas`,
  //   reasons: `${baseApiManagerUrl}/V1/prestadores/:code/pagos-facturas/motivos`,
  //   subReasons: `${baseApiManagerUrl}/V1/prestadores/:code/pagos-facturas/motivos/:id/submotivos`,
  //   statuses: `${baseApiManagerUrl}/V1/prestadores/:code/pagos-facturas/estados`,
  //   consults: `${baseApiManagerUrl}/V1/prestadores/:code/pagos-facturas/consultas`,
  //   consultsByReason: `${baseApiManagerUrl}/V1/prestadores/:code/pagos-facturas/:typeUser/consultas/:reason`,
  //   pdf: `${baseApiManagerUrl}/V1/prestadores/:code/pdf`,
  //   instructions: `${baseApiManagerUrl}/V1/prestadores/:code/pagos-facturas/motivos/:reason/submotivos/:subreason/instrucciones`,
  // },
  // user: {
  //   update: `${baseApiManagerUrl}/V1/prestadores/:code/actualizar/datos`,
  // },
  // users: {
  //   allPermissions: `${baseApiManagerUrl}/V1/prestadores/:code/all-permissions`,
  //   saveChildUser: `${baseApiManagerUrl}/V1/prestadores/:code/registracion/usuario`,
  //   deleteChildUser: `${baseApiManagerUrl}/V1/prestadores/:code/usuarios/:id`,
  //   updateChildUserPermissions: `${baseApiManagerUrl}/V0/prestadores/:code/permisos/usuario`,
  // },
  viewResults: {
    allTests: `${baseApiManagerUrl}/V1/prestadores/:code/informes-medicos`,
    imageTokenUrl: `${baseApiManagerUrl}/V1/prestadores/:code/imagenes/generar-url/token`,
    imagePDFUrl: 'https://imagenes.swissmedical.com.ar/portal/?urltoken=:token',
    viewNoLabTestResult: `${baseApiManagerUrl}/V1/prestadores/:code/:contra/integrantes;nacimiento=:birthDate;documento=:documentNumber/:inte/estudios/clinica/informes/:reportId/imagen/:imageId`,
    viewLabTestResult: `${baseApiManagerUrl}/V1/prestadores/:code/:contra/:documentType/:documentNumber/integrantes/estudios/laboratorio/ordenes/origen/:testNumber/:origin`,
  },
  medicalProviderDirectory: {
    specialities: `${baseApiManagerUrl}/V1/prestadores/:code/cartilla/especialidades`,
    specialitiesUrgentCare: `${baseApiManagerUrl}/V1/prestadores/:code/cartilla/guardias/especialidades`,
    addresses: `${baseApiManagerUrl}/V1/prestadores/:code/cartilla/address`,
    autocompletePractitioner: `${baseApiManagerUrl}/V1/prestadores/:code/cartilla/prestadores?name=:name`,
    searchPracticioners: `${baseApiManagerUrl}/V1/prestadores/:code/cartilla/search`,
  },
  medicalPrescription: {
    getAll: `${baseApiManagerUrl}/V1/prestadores/:code/recetas?contra=:contra&inte=:inte&fecha_desde=:startDate&fecha_hasta=:endDate&cantidad=:quantity&pagina=:page`,
    getFileData: `${baseApiManagerUrl}/V2/rudi/tramites/RCTA/:rudiProcedureNumber`,
    getBase64: `${baseApiManagerUrl}/V3/rudi/tramites/RCTA/:rudiProcedureNumber/archivos/:fileId/base64-content`,
  },
  medicalAttentionAuthorizations: {
    list: `${baseApiManagerUrl}/V1/prestadores/:code/affiliate/authorizations`,
    pdf: `${baseApiManagerUrl}/V1/prestadores/:code/autorizacion/:sucursal/:authorization/pdf`,
  },
  medicalHistory: {
    getAll: `${baseApiManagerUrl}/V1/prestadores/:code/consumos?prepaga=:privateInsurer&contra=:contra&inte=:inte&fecha=:date`,
  },
};

export default urls;
